module.exports = __webpack_public_path__ + "static/media/icon_ceramic_metal_4.20046255.svg";